module.exports = __webpack_public_path__ + "static/media/pay-illustration-login.6263ddcb.svg";